// component

import { FaBookOpen, FaCalendarAlt, FaRegListAlt } from 'react-icons/fa';
import { FiUserPlus } from 'react-icons/fi';
import { FcKindle } from 'react-icons/fc';
import { GoBellFill } from 'react-icons/go';
import { BsFillClipboard2Fill } from 'react-icons/bs';
import { GiArchiveRegister } from 'react-icons/gi';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const getNavConfig = (userRole, userAccess) => {
  const roles = userRole ? userRole.split(',') : [];
  const isTeamKaran = roles.includes('TEAM_KARAN');
  const isAdmin = roles.includes('ADMIN') || roles.includes('EDUTECK');

  // userAccess comes from the login response (response.access): either the
  // string 'ALL' or an array of permission keys, e.g. ['INVOICE_LIST'].
  // null means the backend hasn't implemented access for this account yet —
  // fall back to role-based rules. An explicit empty array means zero access
  // and is handled upstream by the NotAuthorizedGuard, not here.
  const hasAccess = (key) => {
    if (userAccess === 'ALL') return true;
    if (Array.isArray(userAccess)) return userAccess.includes(key);
    return isAdmin || (key === 'INVOICE_LIST' && isTeamKaran);
  };

  return [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: icon('ic_analytics'),
      visible: hasAccess('DASHBOARD'),
    },
    {
      title: 'user',
      path: '/dashboard/user',
      icon: icon('ic_user'),
      visible: hasAccess('USER'),
    },
    {
      title: 'AssignRole',
      path: '/dashboard/AssignRole',
      icon: <FiUserPlus />,
      visible: hasAccess('ASSIGN_ROLE'),
    },
    {
      title: 'Courses',
      path: '/dashboard/Courses',
      icon: <FaBookOpen />,
      visible: hasAccess('COURSES'),
    },
    {
      title: 'Reports',
      path: '/dashboard/products',
      icon: <FaRegListAlt />,
      visible: hasAccess('REPORTS'),
    },
    {
      title: 'Schedular',
      path: '/dashboard/shedular',
      icon: <FaCalendarAlt />,
      visible: hasAccess('SCHEDULAR'),
    },
    {
      title: 'Notification',
      path: '/dashboard/Notification',
      icon: <GoBellFill />,
      visible: hasAccess('NOTIFICATION'),
    },
    {
      title: 'Manage Tests',
      path: '/dashboard/ManageTest',
      icon: <FcKindle />,
      visible: hasAccess('MANAGE_TESTS'),
    },
    {
      title: 'Manage UAC',
      path: '/dashboard/ManageUAC',
      icon: <BsFillClipboard2Fill />,
      visible: hasAccess('MANAGE_UAC'),
    },
    {
      title: 'Manage Demo UAC',
      path: '/dashboard/ManageDemoUAC',
      icon: <BsFillClipboard2Fill />,
      visible: hasAccess('MANAGE_DEMO_UAC'),
    },
    {
      title: 'TeachersEdge UAC',
      path: '/dashboard/TeachersEdgeUAC',
      icon: <BsFillClipboard2Fill />,
      visible: hasAccess('TEACHERS_EDGE_UAC'),
    },
    // {
    //   title: 'StudentUAC',
    //   path: '/dashboard/StudentUAC',
    //   icon: <FcKindle />,
    //   visible: hasAccess('STUDENT_UAC'),
    // },
    // {
    //   title: 'Client Register',
    //   path: '/dashboard/ClientRegister',
    //   icon: <GiArchiveRegister />,
    //   visible: hasAccess('CLIENT_REGISTER'),
    // },
    {
      title: 'Quiz Dashboard',
      path: '/dashboard/QuizDashboard',
      icon: <GiArchiveRegister />,
      visible: hasAccess('QUIZ_DASHBOARD'),
    },
    {
      title: 'Quiz History',
      path: '/dashboard/ExpiredQuiz',
      icon: <GiArchiveRegister />,
      visible: hasAccess('QUIZ_HISTORY'),
    },
    // {
    //   title: 'Assignment Result',
    //   path: '/dashboard/AssignmentResult',
    //   icon: <GiArchiveRegister />,
    //   visible: hasAccess('ASSIGNMENT_RESULT'),
    // },
    {
      title: 'Student List',
      path: '/dashboard/StudentList',
      icon: <GiArchiveRegister />,
      visible: hasAccess('STUDENT_LIST'),
    },
    {
      title: 'Student Lecture Report',
      path: '/dashboard/StudentLectureReport',
      icon: <GiArchiveRegister />,
      visible: hasAccess('STUDENT_LECTURE_REPORT'),
    },
    {
      title: 'Invoice List',
      path: '/dashboard/InvoiceList',
      icon: <GiArchiveRegister />,
      visible: hasAccess('INVOICE_LIST'),
    },
    {
      title: 'Manifest',
      path: '/dashboard/ShiprocketManifest',
      icon: <GiArchiveRegister />,
      visible: hasAccess('MANIFEST'),
    },
    {
      title: 'Generate Content QR',
      path: '/dashboard/GenerateQRContent',
      icon: <GiArchiveRegister />,
      visible: hasAccess('GENERATE_CONTENT_QR'),
    },
    {
      title: 'Educteck Invoice List',
      path: '/dashboard/EduteckInvoiceList',
      icon: <BsFillClipboard2Fill />,
      visible: false,
    },
    // {
    //   title: 'Course Structure',
    //   path: '/dashboard/CourseStucture',
    //   icon: <BsFillClipboard2Fill />,
    //   visible: hasAccess('COURSE_STRUCTURE'),
    // },
    {
      title: 'Course Structure',
      path: '/dashboard/SelectCourseAndSubject',
      icon: <FcKindle />,
      visible: hasAccess('COURSE_STRUCTURE'),
    },
  ].filter((item) => item.visible);
};

export default getNavConfig;
